<template>
<div class="monitoring">

    <div class="page-header">
        <h1><lang labelKey="HEADER_MONITORING"></lang></h1>
    </div>

    <div v-if="isLoading" class="loadingContainer has-text-centered">
        <loading-indicator></loading-indicator>
    </div>

    <template v-else>


        <div class="box industry">

            <div class="boxHeader">
                <lang labelKey="MONITORING_HEADING-INDUSTRY"></lang>
            </div>

            <div class="columns">

                <div class="column">
                    <div v-formatNumberThousands>{{ stats.placementsCount }}</div>
                    <span class="label"><lang labelKey="MONITORING-INDUSTRY-PLACEMENTS"></lang></span>
                </div>

                <div class="column">
                    <div v-formatNumberThousands>{{ stats.manufacturerPagesCount }}</div>
                    <span class="label"><lang labelKey="MONITORING-INDUSTRY-MANUFACTURERS"></lang></span>
                </div>

                <div class="column">
                    <div v-formatNumberThousands>{{ stats.productsCount }}</div>
                    <span class="label"><lang labelKey="MONITORING-INDUSTRY-PRODUCTS"></lang></span>
                </div>

                <div class="column">
                    <div v-formatNumberThousands>{{ stats.productVouchersCount }}</div>
                    <span class="label"><lang labelKey="MONITORING-INDUSTRY-COUPONS"></lang></span>
                </div>

                <div class="column">
                    <div v-formatNumberThousands>{{ formatNumberPointToComma(stats.productVouchersDiscountTotal) }}</div>
                    <span class="label"><lang labelKey="MONITORING-INDUSTRY-COUPONS_VALUE"></lang></span>
                </div>

            </div>

        </div>


        <div class="columns">

            <div class="column is-6">

                <div class="box">

                    <div class="boxHeader">
                        <lang labelKey="MONITORING_HEADING-CLUSTER"></lang>
                    </div>

                    <ul>
                        <li>
                            <div class="w3-light-grey">
                                <div class="w3-container w3-green w3-center" :style="'width: ' + usedPagesCountPercentage + '%'">{{ usedPagesCountPercentage }} %</div>
                            </div>
                        </li>
                        <li><lang labelKey="MONITORING-CLUSTER-USED_PAGES_COUNT"></lang><span v-formatNumberThousands>{{ stats.usedPagesCount }}</span></li>
                        <li><lang labelKey="MONITORING-REDAKTION-NOT_USED_PAGES_COUNT"></lang><span v-formatNumberThousands>{{ stats.pagesCount - stats.usedPagesCount }}</span></li>
                    </ul>

                </div>

                <div class="box">

                    <div class="boxHeader">
                        <lang labelKey="MONITORING_HEADING-EDITORIAL"></lang>
                    </div>

                    <ul>
                        <li><lang labelKey="MONITORING-REDAKTION-INTRO_PAGES"></lang><span v-formatNumberThousands>{{ stats.introPagesCount }}</span></li>
                        <li><lang labelKey="MONITORING-REDAKTION-CHAPTER_INTRO_PAGES"></lang><span v-formatNumberThousands>{{ stats.chapterIntroPagesCount }}</span></li>
                        <li><lang labelKey="MONITORING-REDAKTION-CHAPTER_PAGES"></lang><span v-formatNumberThousands>{{ stats.chapterPagesCount }}</span></li>
                        <li><lang labelKey="MONITORING-REDAKTION-RECIPES_COUNT"></lang><span v-formatNumberThousands>{{ stats.recipesCount }}</span></li>
                        <li><lang labelKey="MONITORING-REDAKTION-TABLE_OF_CONTENTS_PAGES"></lang><span v-formatNumberThousands>{{ stats.tableOfContentsPagesCount }}</span></li>
                        <li><lang labelKey="MONITORING-REDAKTION-INDEX_PAGES"></lang><span v-formatNumberThousands>{{ stats.indexPagesCount }}</span></li>
                        <li><lang labelKey="MONITORING-REDAKTION-APOPEDIA"></lang><span v-formatNumberThousands>{{ stats.apopediaCount }}</span></li>
                        <li><lang labelKey="MONITORING-REDAKTION-EXPERT_ADVICE"></lang><span v-formatNumberThousands>{{ stats.expertAdvicesCount }}</span></li>
                    </ul>

                </div>

            </div>

            <div class="column is-6">

                <div class="box">

                    <div class="boxHeader">
                        <lang labelKey="MONITORING_HEADING-PHARMACIES"></lang>
                    </div>

                    <ul>
                        <li><lang labelKey="MONITORING-PHARMACY-SITE_COUNT"></lang><span>{{ stats.sitesCount }}<span v-html="getDifference(stats.sitesCount, stats.previousSitesCount)"></span></span></li>
                        <li><lang labelKey="MONITORING-PHARMACY-SUBSCRIPTIONS_COUNT"></lang><span v-formatNumberThousands>{{ stats.subscriptionsCount }}</span></li>
                        <li><lang labelKey="MONITORING-PHARMACY-FIRST_TIME_ORDERS"></lang><span v-formatNumberThousands>{{ stats.firstTimeOrdersCount }}</span></li>
                        <li><lang labelKey="MONITORING-PHARMACY-CUSTOMIZATIONS_COUNT"></lang><span v-formatNumberThousands>{{ stats.customizationsCount }}</span></li>
                        <li><lang labelKey="MONITORING-PHARMACY-PACKAGE_1"></lang><span v-formatNumberThousands>{{ stats.packagesU1U4Count }}</span></li>
                        <li><lang labelKey="MONITORING-PHARMACY-PACKAGE_2"></lang><span v-formatNumberThousands>{{ stats.packagesU1U4U2Count }}</span></li>
                        <li><lang labelKey="MONITORING-PHARMACY-PACKAGE_3"></lang><span v-formatNumberThousands>{{ stats.packagesU1U4U2USCount }}</span></li>
                        <li><lang labelKey="MONITORING-PHARMACY-VOUCHER_PACKAGES"></lang><span>{{ stats.voucherPackagesCount != null ? stats.voucherPackagesCount : 0 }}</span></li>

                        <li><lang labelKey="MONITORING-PHARMACY-QUANTITY_TOTAL"></lang><span>{{ stats.quantityTotal != null ? thousandsSeparator(stats.quantityTotal) : 0 }}<span v-html="thousandsSeparator(getDifference(stats.quantityTotal, stats.previousQuantityTotal))"></span></span></li>
                        <li><lang labelKey="MONITORING-PHARMACY-SHIPMENTS_COUNT"></lang><span>{{ stats.shipmentsCount }}<span v-html="getDifference(stats.shipmentsCount, stats.previousShipmentsCount)"></span></span></li>
                        <li><lang labelKey="MONITORING-PHARMACY-SITES_HAVING_COUPON_SETS"></lang><span>{{ stats.sitesHavingCouponSetsCount }}{{ stats.couponSetQuantityTotal > 0 ? ' ('+stats.couponSetQuantityTotal+' Sets)' : ''}}</span></li>
                        <li><lang labelKey="MONITORING-PHARMACY-CANCELLATIONS_COUNT"></lang><span>{{ stats.cancellationsCount }}<span v-html="getDifference(stats.cancellationsCount, stats.previousCancellationsCount)"></span></span></li>

                    </ul>

                </div>


            </div>

        </div>

    </template>

</div>

</template>


<script>
export default {

    name: "monitoring",

    data() {

        return {
            isLoading: false,
            stats: ''
        }

    },

    created() {
		this.fetchData();
	},

    mounted() {

	},


    computed: {

        usedPagesCountPercentage() {

            if(this.stats.usedPagesCount == 0 || this.stats.pagesCount == 0) {
                return 0;
            }
            
            return (this.stats.usedPagesCount / this.stats.pagesCount * 100).toFixed(2);

        }

    },

    directives: {

        formatNumberThousands: {

            // directive definition
            bind: function (el) {
                return el.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
            }
        }
    },

    methods: {

        thousandsSeparator (num) {
            return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
        },

        formatNumberPointToComma(number) {

			if(number == null || number == "" || typeof number == "undefined") {
				number = 0;
			}

			return (number.toString()).replace(".", ",");

        },

        getDifference(current, prev) {

            if(current == null || prev == null || current == 0 && prev == 0) {
                return ''
            }

            var diff = "<span class='difference'>(";

            if(parseInt(current) > parseInt(prev)) {

                diff += "<span class='statsHigher'>+" + (parseInt(current) - parseInt(prev)) + "</span>";

            } else if (parseInt(current) == parseInt(prev)) {

                diff += "<span>0</span>";

            } else {

                diff += "<span class='statsLower'>" + (parseInt(current) - parseInt(prev)) + "</span>";

            }

            return diff + ')</span>';

        },


        fetchData() {

            this.isLoading = true;
            var self = this;

            var apiURL = this.$config.api + 'apokatStat/stats?catalog='+self.catalogId;

            // fetch data
            this.axios.get(apiURL)
                .then(function(response) {
                    self.stats = response.data.apokatStat;
                    self.isLoading = false;

                }).catch(function(error) {
                    self.isLoading = false;
                    console.log('Error: ', error.message);
                });

        }

    }

}



</script>


<style lang="scss" scoped>

    @import '~../../assets/css/variables.scss';

    .box {
        padding: 0;
    }
    .box .boxHeader {
        margin: 0;
        padding: 6px 12px;
    }

    .box ul li {
        padding: 10px 20px;
        margin: 0;
        font-size: 13px;
        clear: both;
    }
    .box ul li:nth-child(even) {
        background: $themeTblCellEvenColor;
    }
    .box ul li:nth-child(odd) {
        background: $themeTblCellOddColor;
    }

    .box ul li:last-child {
        border-bottom: none;
    }
    .box ul li span {
        display: inline-block;
    }
    .box ul li span:first-child {

    }
    .box ul li span:nth-child(2) {
        float: right;
    }


    .box.industry .column {
        text-align: center;
        padding: 20px 3%;
    }
    .box.industry .column div {
        color: $themeColor2;
        font-size: 3.2rem;
        font-weight: 400;
        padding-bottom: 0;
        margin: 0 0 3px 0;
        border-bottom: 1px solid #ddd;
        display: block;
    }
    .box.industry .column span {
        color: $themeColor2;
        font-weight: 300;
    }
</style>

<style>

    .w3-light-grey, .w3-hover-light-grey:hover, .w3-light-gray, .w3-hover-light-gray:hover {
        color: #000!important;
        background-color: #f1f1f1!important;
    }

    .w3-green, .w3-hover-green:hover {
        color: #fff !important;
        background-color: #50e3c2 !important;
    }
    .w3-center {
        text-align: center !important;
    }
    .w3-container, .w3-panel {
        padding: 0.6rem 16px;
        background: #ddd;
    }

    .difference {
        font-size: 0.85em;
        margin-left: 5px;
    }

    .difference .statsLower {
        color: red !important;
    }
    .difference .statsHigher {
        color: limegreen !important;
    }

</style>
